window.addEventListener('DOMContentLoaded', () => {
	const tables = document.querySelectorAll('.comparison .table')

	tables.forEach(table => {
		const toggleMonthly = table.querySelectorAll('.billing-toggle .monthly')
		const toggleAnnual = table.querySelectorAll('.billing-toggle .annual')
		const monthlyPrices = table.querySelectorAll('.monthly-price')
		const annualPrices = table.querySelectorAll('.annual-price')
		const monthlyButtons = table.querySelectorAll('.button.monthly')
		const annualButtons = table.querySelectorAll('.button.annual')

		toggleMonthly.forEach(toggle => {
			toggle.addEventListener('click', () => {
				switchToMonthly()
			})
		})

		toggleAnnual.forEach(toggle => {
			toggle.addEventListener('click', () => {
				switchToAnnual()
			})
		})

		function switchToMonthly() {
			toggleMonthly.forEach(toggle => {
				toggle.classList.add('active')
			})
			toggleAnnual.forEach(toggle => {
				toggle.classList.remove('active')
			})

			monthlyPrices.forEach(price => {
				price.classList.add('active')
			})
			annualPrices.forEach(price => {
				price.classList.remove('active')
			})

			monthlyButtons.forEach(button => {
				button.classList.add('active')
			})
			annualButtons.forEach(button => {
				button.classList.remove('active')
			})
		}

		function switchToAnnual() {
			toggleMonthly.forEach(toggle => {
				toggle.classList.remove('active')
			})
			toggleAnnual.forEach(toggle => {
				toggle.classList.add('active')
			})

			monthlyPrices.forEach(price => {
				price.classList.remove('active')
			})
			annualPrices.forEach(price => {
				price.classList.add('active')
			})

			monthlyButtons.forEach(button => {
				button.classList.remove('active')
			})
			annualButtons.forEach(button => {
				button.classList.add('active')
			})
		}
	})
})
